(function () {
  const EASIFY_RADIO_SELECTOR = 'input[type="radio"][name$=",Afhaallocatie"]';

  // availabilityData maps lowercased location name → boolean
  const availabilityData = new Map();

  function setAvailability(name, value) {
    availabilityData.set(name.toLowerCase(), value);
  }

  function getAvailability(name) {
    return availabilityData.get(name.toLowerCase());
  }

  function getSelectedLocation() {
    return document.querySelector(`${EASIFY_RADIO_SELECTOR}:checked`)?.value ?? null;
  }

  // Update Easify's radio buttons: disable when out of stock, show status badge.
  // Returns true if the currently selected radio was invalidated.
  function updateEasifyRadios() {
    if (!document.querySelector(EASIFY_RADIO_SELECTOR)) return false;

    let selectionInvalidated = false;

    document.querySelectorAll(EASIFY_RADIO_SELECTOR).forEach((radio) => {
      const available = getAvailability(radio.value);
      const label = radio.closest('label');
      const wrapper = radio.closest('.tpo_radio-button-wrapper');

      label?.querySelector('.location-stock-badge')?.remove();

      if (available !== undefined) {
        const badge = document.createElement('span');
        badge.className = `location-stock-badge location-stock-badge--${available ? 'available' : 'unavailable'}`;
        badge.textContent = available ? 'Op voorraad' : 'Niet op voorraad';
        label?.querySelector('.tpo_option_type_label')?.appendChild(badge);

        const wasChecked = radio.checked;
        radio.disabled = !available;
        wrapper?.classList.toggle('location-stock--disabled', !available);

        if (!available && wasChecked) {
          radio.checked = false;
          selectionInvalidated = true;
        }
      }
    });

    return selectionInvalidated;
  }

  function init(productFormEl) {
    const form = productFormEl.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const submitButton = form?.querySelector('[type="submit"][name="add"]');

    if (!variantInput || !submitButton) return;

    const winkelInput = document.createElement('input');
    winkelInput.type = 'hidden';
    winkelInput.name = 'properties[Winkel]';
    winkelInput.value = '';
    form.appendChild(winkelInput);

    const unavailableMsg = document.createElement('p');
    unavailableMsg.className = 'location-stock__unavailable';
    unavailableMsg.hidden = true;
    submitButton.parentElement.insertBefore(unavailableMsg, submitButton);

    let locationDisabled = false;

    function getRootUrl() {
      let url = window.location.origin;
      return url.endsWith('/') ? url : url + '/';
    }

    function applyLocationCheck(selectionInvalidated = false) {
      const selected = getSelectedLocation();

      winkelInput.value = (!selectionInvalidated && selected) ? selected : '';

      if (!selected || selectionInvalidated) {
        locationDisabled = true;
        submitButton.disabled = true;
        unavailableMsg.textContent = 'Selecteer een beschikbare afhaallocatie.';
        unavailableMsg.hidden = false;
        return;
      }

      const available = getAvailability(selected);

      if (available === false) {
        locationDisabled = true;
        submitButton.disabled = true;
        unavailableMsg.textContent = 'Dit product is niet beschikbaar voor afhalen op deze locatie.';
        unavailableMsg.hidden = false;
      } else {
        unavailableMsg.hidden = true;
        if (locationDisabled) {
          locationDisabled = false;
          submitButton.disabled = false;
        }
      }
    }

    // Re-apply our check whenever Shopify re-enables the button after a variant change.
    new MutationObserver(() => {
      if (locationDisabled && !submitButton.disabled) {
        submitButton.disabled = true;
      }
    }).observe(submitButton, { attributes: true, attributeFilter: ['disabled'] });

    function onFetchComplete() {
      const invalidated = updateEasifyRadios();
      applyLocationCheck(invalidated);

      // Easify renders async — watch for its radios if they aren't in the DOM yet.
      if (!document.querySelector(EASIFY_RADIO_SELECTOR)) {
        const observer = new MutationObserver(() => {
          if (document.querySelector(EASIFY_RADIO_SELECTOR)) {
            observer.disconnect();
            const inv = updateEasifyRadios();
            applyLocationCheck(inv);
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 10000);
      }
    }

    function fetchAvailability(variantId) {
      if (!variantId) return;
      const rootUrl = getRootUrl();
      fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          availabilityData.clear();
          const items = doc.querySelectorAll('.pickup-availability-list__item[data-location]');
          items.forEach((item) => {
            setAvailability(item.dataset.location, item.dataset.available === 'true');
          });
          onFetchComplete();
        })
        .catch((err) => console.error('[location-stock] fetch error:', err));
    }

    productFormEl.addEventListener('easify:location-change', () => applyLocationCheck());
    variantInput.addEventListener('change', () => fetchAvailability(variantInput.value));
    fetchAvailability(variantInput.value);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productForms = document.querySelectorAll('product-form');
    productForms.forEach(init);

    // Event delegation so Easify's async-rendered radios are always caught.
    document.addEventListener('change', (e) => {
      if (e.target.matches(EASIFY_RADIO_SELECTOR)) {
        productForms.forEach((el) => {
          el.dispatchEvent(new CustomEvent('easify:location-change'));
        });
      }
    });
  });
})();
